import { useEffect, useState, React, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
//import ci from "../../../../../../images/cutis_new.jpeg";
//import "../../../../CRM/styles/style.css";
import ReactToPrint from "react-to-print";
import axios from "axios";

import PrintBill from "./PrintBill";
import validator from "validator";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  getInventoryItems,
  getInventoryPurchase,
} from "../../../../../redux/inventory";
import InventoryForm from "../../InventoryForm";
import { FiMinusCircle, FiPlus, FiPlusCircle, FiTrash2 } from "react-icons/fi";
import { useSaveRtnPurchase } from "./useSaveRtnPurcahse";
import { getInventoryByProductId } from "../../API/getInventoryByProduct";

const PurchaseEntry = ({
  purchaseInvoiceFormData = {},
  selectedRtnDate,
  editInventoryData,
  clearSupplierForm,
  setShowModal,
  togglePurchaseEntry,
  mode,
  itemsData,
  setSearchInputByClick,
  setRefresh,
  refresh,
  onlyInventoryAdd
}) => {
  const auth = useSelector((state) => state.authentication);
  const itemsList = useSelector((state) => state.itemsList);
  const { purchaseData, supplierData } = itemsList || [];
  const dispatch = useDispatch();
  const { userData } = auth;
  let savedToggle = false;
  const token = sessionStorage.getItem("token")
    ? JSON.parse(sessionStorage.getItem("token"))
    : "";
  const [username] = useState(
    sessionStorage.getItem("username")
      ? JSON.parse(sessionStorage.getItem("username"))
      : ""
  );
  const componentRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const date = new Date();
  const [mrn, setMrn] = useState(data && data.otData.mrn);
  const dateNew = new Date();
  const datewithoutHours = new Date(dateNew.setHours(0, 0, 0, 0)).toISOString();
  const time = date.getTime();
  const branch = data ? data.branch : userData.branch;
  //const [payment_mode, setPayment_mode] = useState("cash");
  // const [amount_paid, setAmountPaid] = useState("");
  const invoice_id = `INV-${Date.now()}`;
  const status = "";
  const remarks = "";
  const [buttonHide, setButtonHide] = useState({ display: "normal" });
  const [printVisible, setPrintVisible] = useState(false);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const saveRtnPurchase = useSaveRtnPurchase(
    userData,
    togglePurchaseEntry,
    setShowModal
  );

  const [address, setAddress] = useState("");
  const [addressPrint, setAddressPrint] = useState("");
  const [total, setTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [netAmountPay, setNetAmountPay] = useState("");
  const total_amount = total;
  const total_amount_paid = netAmountPay;
  const [procedures, setProcedures] = useState("");
  const [GSTIN, setGSTIN] = useState("");
  const [discount, setDiscount] = useState("");
  const [receivedAmt, setReceivedAmt] = useState("");
  const [balanceAmount, setBalanceAmount] = useState("");
  const [searchResult, setSearchResult] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [formDataPurchase, setFormDataPurchase] = useState(
    purchaseInvoiceFormData
  );
  const [filteredSheets, setFilteredSheets] = useState("");
  const taxOptions = [
    { value: "", label: "" },
    { value: "none", label: "None" },
    { value: "exempted", label: "Exempted" },
    { value: "0", label: "GST @ 0%" },
    { value: "0.1", label: "GST @ 0.1%" },
    { value: "0.25", label: "GST @ 0.25%" },
    { value: "1.5", label: "GST @ 1.5%" },
    { value: "3", label: "GST @ 3%" },
    { value: "5", label: "GST @ 5%" },
    { value: "6", label: "GST @ 6%" },
    { value: "12", label: "GST @ 12%" },
    { value: "13.8", label: "GST @ 13.8%" },
    { value: "18", label: "GST @ 18%" },
    { value: "14_12", label: "GST @ 14% + cess @ 12%" },
    { value: "28", label: "GST @ 28%" },
    { value: "28_12", label: "GST @ 28% + cess @ 12%" },
    { value: "28_60", label: "GST @ 28% + cess @ 60%" },
  ];
  const [invoiceSheet, setInvoiceSheet] = useState([
    {
      item: "",
      quantity: "",
      unit: "",
      unitPrice: 0,
      tax: 0,
      mrp: 0,
      hsn: "",
      batch: "",
      productId: "",
      stockQty: "",
      expiry: "",
    },
  ]);

  const [rowIndex, setRowIndex] = useState(0);
  const [totalQTY, setTotalQTY] = useState("");
  const [totalTax, setTotalTax] = useState("");
  const [taxableData, setTaxableData] = useState("");
  const invoice_sheet = invoiceSheet;
  const [formData, setFormData] = useState("");
  const [inventoryFormData, setInventoryFormData] = useState("");
  
  const clearForm = () => {
    setInvoiceSheet([
      {
        item: "",
        quantity: "",
        unit: "",
        unitPrice: 0,
        tax: 0,
        mrp: 0,
      },
    ]);
  };
  
useEffect(() => {
  if (
    userData?.token &&
    userData?.branch &&
    ["Accounts", "Manager", "Admin"].includes(userData?.rights)
  ) {
    dispatch(getInventoryItems({ token: userData.token, branch: userData.branch }));
  }
}, [ userData?.token,
    userData?.branch ]);
  
  useEffect(() => {
    // && userData.rights === "Accounts" removed it , check what is the need
    if (data && data.invoiceSheetData) {
      setInvoiceSheet(data.invoiceSheetData);
    }
    if (purchaseInvoiceFormData && purchaseInvoiceFormData.invoice) {
      const convertObjectToArray = (obj) => {
        return Object.values(obj);
      };

      // const invoiceArray = convertObjectToArray(purchaseInvoiceFormData.invoice);
      const invoice = Array.isArray(purchaseInvoiceFormData.invoice)
        ? purchaseInvoiceFormData.invoice
        : convertObjectToArray(purchaseInvoiceFormData.invoice);

      setInvoiceSheet(invoice);

      // for old entries
    } else if (
      purchaseInvoiceFormData?.paymentDetails &&
      purchaseInvoiceFormData.paymentDetails.invoice_id
    ) {
      const itemsSheet = itemsData.filter(
        (item) =>
          item.invoice_id === purchaseInvoiceFormData.paymentDetails.invoice_id
      );

      // const convertObjectToArray = (obj) => {
      //   return Object.keys(obj).map((key, index) => {
      //     return {
      //       [`Row${index + 1}`]: obj[key],
      //     };
      //   });
      // };
    }

    if (editInventoryData) {
      setInvoiceSheet([{ ...editInventoryData }]);
    }
  }, [data, purchaseInvoiceFormData?.invoice, editInventoryData]);

  useEffect(() => {
    if (receivedAmt) {
      setBalanceAmount(() =>
        (parseFloat(netAmountPay) - parseFloat(receivedAmt)).toFixed(2)
      );
    }
  }, [receivedAmt]);

  useEffect(() => {
    if (tax || total || discount) {
      // const taxTemp = ((Number(total)) / 100).toFixed(2);
      // const rowTotal = (parseFloat(taxTemp) + parseFloat(total)).toFixed(2);
      const netPay = (parseFloat(total) - parseFloat(discount)).toFixed(2);

      setNetAmountPay(() =>
        !isNaN(netPay) ? netPay : parseFloat(total).toFixed(2)
      );
    }
  }, [tax, total, discount]);

   

    

  useEffect(() => {
    if (printVisible) {
      setButtonHide({ display: "none" });
    }
    // setButtonHide({ display: "none" });
    // return () => setPrintVisible(false);
  }, [printVisible]);

 const inventoryAddHandler = async (filteredData) => {
  const { supplier } = purchaseInvoiceFormData;

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}process-inventory`,
      {
        branch: userData.branch,
        type: "purchase",
        reference: purchaseInvoiceFormData?.paymentDetails?.invoice_id,
        supplierId: supplier?.supplierId,
        user: userData?.name,
        rows: filteredData,
      },
      {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    if (!response.data?.success) {
      throw new Error("Inventory processing failed");
    }

    // ✅ Save purchase AFTER inventory success
    await savePurchaseHandler(filteredData);

    // ✅ Refresh inventory once
    dispatch(
      getInventoryItems({
        token: userData.token,
        branch: userData.branch,
      })
    );

    alert("Inventory & Purchase Saved Successfully");
  //  togglePurchaseEntry();

  } catch (error) {
    console.error("Inventory Error:", error);
    throw error;
  }
};
  

  const inventoryEditHandler = async (filteredData) => {
  alert("Inventory Edit Handler");
  console.log("Filtered Data:", filteredData);

  try {
    // ✅ Step 1: Validate rows first
    const validRows = filteredData.filter((row) => {
      if (!row.productId || !row.batch || !row.item) {
        console.warn("Invalid row skipped:", row);
        return false;
      }
      return true;
    });

    if (!validRows.length) {
      throw new Error("No valid rows to update");
    }

    // ✅ Step 2: Check existence in parallel (FAST 🚀)
    const checks = await Promise.all(
      validRows.map((row) =>
        getInventoryByProductId(
          userData.token,
          userData.branch,
          row.productId,
          row.batch
        )
      )
    );

    // ✅ Step 3: Filter only existing inventory
    const selectedSheets = validRows.filter((row, index) => {
      if (!checks[index]) {
        console.warn(
          `Inventory not found for ${row.item} (Batch: ${row.batch})`
        );
      }
      return checks[index];
    });

    if (!selectedSheets.length) {
      throw new Error("No matching inventory records found");
    }

    // ✅ Step 4: Update in parallel
    await Promise.all(
      selectedSheets.map((sheet) => editInventoryHandler(sheet))
    );

    // ✅ Step 5: Success
    setSearchInputByClick();
    alert("Inventory updated successfully");
    clearForm();
   // togglePurchaseEntry();

  } catch (error) {
    console.error("Error updating inventory:", error);
    alert(error.message || "Failed updating inventory");
  } finally {
    setShowModal(false);
  }
};

   const inventoryEditHandlerNew = (sheet) => {
     
     // working edit inventory from her
     const promises = sheet.map((sheet) => editInventoryHandler(sheet))
     Promise.all(promises)
       .then((res) => {
         if (res) {
           //  dispatch(
           //    getInventoryItems({
           //      token: userData.token,
           //      branch: userData.branch,
           //    })
           //  );
           alert("Inventory updated successfully");
           clearForm();
          // togglePurchaseEntry();
         }
       })
       .catch((error) => {
         console.error("Error updating inventory:", error);
         alert("Failed updating inventory");
       })
       .finally(() => {
         setShowModal(false);
       });
   };

  const calculateTotal = () => {
    const amountValues = invoiceSheet
      .map((row) => parseFloat(row.amount))
      .filter((val) => !isNaN(val));

    const qtyValues = invoiceSheet
      .map((row) => parseFloat(row.quantity))
      .filter((val) => !isNaN(val));

    const taxValues = invoiceSheet
      .map((row) => parseFloat(row.tax))
      .filter((val) => !isNaN(val));

    const taxableList = invoiceSheet.filter((row) => parseFloat(row.tax));

    setTaxableData(taxableList);

    const totalTempTax = taxValues.reduce((acc, val) => acc + val, 0);
    setTotalTax(totalTempTax.toFixed(2));

    const totalTempQty = qtyValues.reduce((acc, val) => acc + val, 0);
    setTotalQTY(totalTempQty);

    const totalTempAmt = amountValues.reduce((acc, val) => acc + val, 0);
    setTotal(totalTempAmt.toFixed(2));
  };

  useEffect(() => {
    if (invoiceSheet) calculateTotal();
  }, [data, invoiceSheet]);

  const handleInputProcedure = (e, rowIndex, colName) => {
    const { value } = e.target;
    const trimmedValue = value.trim();

    const selectedOption = e.target.list?.querySelector(
      `option[value="${trimmedValue}"]`
    );

    const cost = selectedOption?.getAttribute("data-cost") ?? null;
    const productId = selectedOption?.getAttribute("data-productid") ?? null;
    const unit = selectedOption?.getAttribute("data-unit") ?? null;
    const unitPrice = selectedOption?.getAttribute("data-unitprice") ?? null;
    const tax = selectedOption?.getAttribute("data-tax") ?? null;
    const product = selectedOption?.getAttribute("data-product") ?? null;
    const stockQty = selectedOption?.getAttribute("data-qty") ?? null;
    const batch = selectedOption?.getAttribute("data-batch") ?? null;
    const expiry = selectedOption?.getAttribute("data-expiry") ?? null;
    const hsn = selectedOption?.getAttribute("data-hsn") ?? null;

    setInvoiceSheet((prevInvoiceSheet) =>
      prevInvoiceSheet.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...row,
            [colName]: product,
            mrp: cost,
            unit,
            unitPrice,
            quantity: product ? 0 : "",
            tax,
            hsn,
            batch,
            productId,
            stockQty,
            expiry,
          };
        }
        return row;
      })
    );
  };

  const handleInputChange = (e, index, key) => {
    const updated = [...invoiceSheet];
    updated[index][key] = e.target.value;
    setInvoiceSheet(updated);
  };

  // 3535 ron bus
  // km 65728 km 28-aug-23
 

  const qtyHandler = (e, index, colName) => {
    const value = e.target.value;

    const isNum = validator.isNumeric(value, { no_symbols: false });
    const isDecimal = validator.isFloat(value, { no_symbols: false });

    if (value !== "-" && (isDecimal || isNum || value === "")) {
      handleInputChange(e, index, colName);

      setInvoiceSheet((prevInvoiceSheet) =>
        prevInvoiceSheet.map((row, rindex) =>
          rindex === index
            ? {
                ...row,
                quantity: parseFloat(value) || "", // allow clearing the field
              }
            : row
        )
      );
    } else {
      alert("Enter Numeric Value");
    }
  };

  useEffect(() => {
    if (inventoryFormData && rowIndex >= 0) {
      setInvoiceSheet((prev) =>
        prev.map((row, index) =>
          index === rowIndex ? { ...row, ...inventoryFormData } : row
        )
      );
    }
    console.log(inventoryFormData);
  }, [inventoryFormData, rowIndex]);

  useEffect(() => {
    console.log(invoiceSheet);
  }, [invoiceSheet]);

  const handlePrintButtonClick = () => {
    //console.log("Button clicked");
    setPrintVisible(true);
  };

  const searchPurchaseHandler = (value) => {
    const invId =
      searchResult &&
      searchResult.find(
        (item) => item.invoice_id.toLowerCase() == value.toLowerCase()
      );

    if (value.length > 5 && !invId) {
      //searchInvoices(userData.token, value, userData.branch, navigate).then(
    }
    if (invId) {
      //  //token, searchInput, branch, navigate
      //  searchCustomers(
      //    userData.token,
      //    invId.mrn,
      //    userData.branch,
      //    navigate
      //  ).then((res) => {
      //    if (res.length) {
      //      const [{ fname, sname = "", sex = "", contactno, nationality }] = res;
      //      if (fname || sname) setDiscount(invId.discount);
      //      setFormData({
      //        ...invId,
      //        patientName: `${fname} ${sname}`,
      //        sex: sex,
      //        contactNo: contactno,
      //        nationality,
      //      });
      //    }
      //  });
      //  //setMrn(invId.mrn);
      // setInvoiceSheet(() => invId.invoice_sheet);
    }
  };
  const handleManualEntry = (e, rindex, field, rowData) => {
    const newValue = e.target.value;

    const isManualItem = !itemsData?.find((item) => item.item === newValue);

    if (isManualItem) {
      setInvoiceSheet((prevInvoiceSheet) =>
        prevInvoiceSheet.map((row, index) =>
          index === rindex
            ? {
                ...row,
                [field]: newValue,
              }
            : row
        )
      );
    }
  };

    const savePurchaseHandler = async (updatedInvoiceSheet) => {
  if (mode === "Return Mode") return;

  const { supplier, paymentDetails, additionalDetails, createdBy } =
    purchaseInvoiceFormData;

  const postPurchaseData = {
    supplier,
    paymentDetails,
    additionalDetails,
    createdBy,
    invoice: updatedInvoiceSheet,
  };
   console.log("Post Purchase Data:", purchaseInvoiceFormData);
  try {
    if (!purchaseInvoiceFormData?.purchaseId && !onlyInventoryAdd) {
      alert("Saving new purchase entry");
      const res = await axios.post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}add-purchase`,
        postPurchaseData,
        {
          params: {
            branch: userData.branch,
            userName: userData.userName,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      if (res.status === 200) {
        dispatch(
          getInventoryPurchase({
            token: userData.token,
            branch: userData.branch,
          })
        );
      }
    } else if (purchaseInvoiceFormData?.purchaseId) {
      await editPurchaseHandler(postPurchaseData);
    }

  } catch (err) {
    console.error("Purchase Save Error:", err);

    if (
      err?.response?.data?.err?.name === "TokenExpiredError" ||
      err?.response?.data?.message === "Unauthorized"
    ) {
      sessionStorage.clear();
      return;
    }

    throw err;
  }
};


 const submitPurchaseHandler = async (filteredData) => {
  if (!filteredData?.length) {
    alert("Please enter invoice item details");
    return;
  }

  if (mode === "Return Mode") {
    if (!purchaseInvoiceFormData?.additionalDetails?.returnReason) {
      alert("Please mention return reason");
      return;
    }
    alert("Return flow not implemented");
    return;
  }

  try {
    // ✅ Step 1: Check duplicate invoice
    const checkRes = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}check-purchase-invoice`,
      {
        invoice_id: purchaseInvoiceFormData?.paymentDetails?.invoice_id,
        supplierId: purchaseInvoiceFormData?.supplier?.supplierId,
      },
      {
        params: { branch: userData.branch },
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    if (checkRes.data?.exists) {
      alert("Invoice already exists for this supplier");
      return;
    }

    // ✅ Step 2: Process Inventory + Save Purchase
    await inventoryAddHandler(filteredData);

  } catch (error) {
    console.error("Submit Error:", error);
    alert(error.response?.data?.message || "Something went wrong");
  }
};

  const purchaseFormValid = () => {
    if (
      purchaseInvoiceFormData &&
      !purchaseInvoiceFormData?.supplier?.supplierId
    ) {
      alert("Please select supplier");
      return false;
    }
    if (
      purchaseInvoiceFormData &&
      !purchaseInvoiceFormData.paymentDetails.invoice_date
    ) {
      alert("No Invoice Date selected");
      return false;
    }
    if (
      purchaseInvoiceFormData &&
      !purchaseInvoiceFormData.paymentDetails.invoice_id
    ) {
      alert("Enter Invoice Number");
      return false;
    }
    if (
      purchaseInvoiceFormData &&
      !purchaseInvoiceFormData.paymentDetails.amount_paid && !purchaseInvoiceFormData.paymentDetails.total_amount
    ) {
      alert("Please enter amount paid");
      return false;
    }

    if (branch && datewithoutHours) {
      if (
        (purchaseInvoiceFormData &&
          purchaseInvoiceFormData.paymentDetails.payment_mode) ||
        mode === "Return Mode"
      ) {
        return true;
      } else if (purchaseInvoiceFormData &&
          purchaseInvoiceFormData.paymentDetails.amount_paid > 0) {

         alert("Select Payment Mode");
        return false;
      }
    } else {
      alert("Invalid Form");
      return false;
    }
    return true;
  };

   const invoiceSheetValid = () => {
  let valid = true;
  const errors = [];

  const filteredData = invoiceSheet
    .filter((row) => {
      if (!row?.item) return false;

      if (!row.quantity || row.quantity <= 0) {
        errors.push(`Invalid qty: ${row.item}`);
        valid = false;
        return false;
      }

      if (!row.batch) {
        errors.push(`Missing batch: ${row.item}`);
        valid = false;
        return false;
      }

      return true;
    })
    .map((row) => ({
      ...row,
      invoice_id:
        editInventoryData?.invoice_id ||
        purchaseInvoiceFormData?.paymentDetails?.invoice_id,
    }));

  if (errors.length) {
    alert(errors.join("\n"));
  }

  if (valid) setFilteredSheets(filteredData);

  return { filteredData, valid };
};

const validateRow = (row) => {
  if (!row.item) throw new Error("Item missing");
  if (!row.batch) throw new Error(`Batch missing for ${row.item}`);
  if (!row.quantity || row.quantity <= 0)
    throw new Error(`Invalid quantity for ${row.item}`);

  return true;
};


  const handleSubmit = async () => {


  try {
    const { filteredData, valid } = invoiceSheetValid();

    if (!valid) {
      throw new Error("Invalid invoice data");
    }

    // ✅ 🔥 ADD VALIDATION HERE
    filteredData.forEach(validateRow);

    if (!editInventoryData && !purchaseFormValid()) {
      throw new Error("Purchase form invalid");
    }
     
    if (editInventoryData) {
      alert("Editing inventory and purchase");
      await inventoryEditHandler(filteredData);
    } else {
      await submitPurchaseHandler(filteredData);
    }

  } catch (error) {
    console.error(error);
    alert(error.message || "Process failed");
  }
};

  const editPurchaseHandler = () => {
    if (
      purchaseInvoiceFormData.purchaseId &&
      purchaseInvoiceFormData.paymentDetails.invoice_id
    ) {
      const { supplier, paymentDetails, additionalDetails, createdBy } =
        purchaseInvoiceFormData;
      const postPurchaseData = {
        supplier,
        paymentDetails,
        additionalDetails,
        createdBy,
        invoice: invoiceSheet,
      };

      axios
        .post(
          `${process.env.REACT_APP_COLLEGE_ERP_API}edit-purchase`,
          postPurchaseData,
          {
            params: {
              branch: userData.branch,
              purchaseId: purchaseInvoiceFormData.purchaseId,
              userName: userData.userName,
            },
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            //  inventoryAddHandler(filteredData.invoice);

            alert("Edit success");
            clearForm();
            // clearForm();
          }
        })
        .catch((err) => console.log(err));
    } else {
      // submitPurchaseHandler(filteredData);
    }
  };

  // since return is kind of edit and save as a new entry in db , these end point is accessed from here
  const editInventoryHandler = (selectedItemsInvoiceSheet) => {
    const endpoint = "edit-inventory";
    alert("endpoint API ");
    return axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}${endpoint}`,
      selectedItemsInvoiceSheet,
      {
        params: {
          branch: userData.branch,
          productId: selectedItemsInvoiceSheet.productId,
          userName: userData.userName,
        },
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    ).finally(() => {     
       setRefresh(!refresh)
    });
  }; 

  return (
    <Container
      className="pb-0 m-0"
      style={{
        overflowX: "auto",
        maxHeight: "70vh",
        maxWidth: "100%",
      }}
    >
      <Table bordered className="m-0">
        <thead>
          <tr>
            <th
              style={{
                //   backgroundColor: "#8b0f7a",
                width: "5%",
                textAlign: "center",
                border: "none",
                // color: "white",
              }}
            >
              Sl No.
            </th>
            <th
              style={{
                width: "20%",
                textAlign: "center",
                border: "none",
                // color: "white",
                // backgroundColor: "#8b0f7a",
              }}
            >
              ITEMS/SERVICES
            </th>
            <th
              style={{
                width: "10%",
                textAlign: "center",
                border: "none",
                // color: "white",
                //    backgroundColor: "#8b0f7a",
              }}
            >
              HSN
            </th>
            {
              <th
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "none",
                  // color: "white",
                  //    backgroundColor: "#8b0f7a",
                }}
              >
                QTY
              </th>
            }
            <th
              style={{
                width: "10%",
                textAlign: "center",
                border: "none",
                // color: "white",
                // backgroundColor: "#8b0f7a",
              }}
            >
              Unit
            </th>
            <th
              style={{
                width: "10%",
                textAlign: "center",
                border: "none",
                // color: "white",
                // backgroundColor: "#8b0f7a",
              }}
            >
              Unit Price
            </th>
            {
              <th
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "none",
                  //color: "white",
                  //  backgroundColor: "#8b0f7a",
                }}
              >
                TAX
              </th>
            }
            {
              <th
                style={{
                  width: "10%",
                  border: "none",
                  // color: "white",
                  //   backgroundColor: "#8b0f7a",
                  textAlign: "center",
                }}
              >
                {" "}
                MRP
              </th>
            }

            <th style={{ width: "5%" }}>Add</th>
          </tr>
        </thead>
        <tbody>
          {invoiceSheet.map((row, index) => (
            <tr key={index}>
              <td style={{ textAlign: "center" }}>{row.item && index + 1}</td>

              <td>
                <Input
                  type="text"
                  list="data"
                  autoComplete="off"
                  value={row.item}
                  onChange={(e) => handleInputProcedure(e, index, "item")}
                  onBlur={(e) => handleManualEntry(e, index, "item")}
                />
                <datalist id="data">
                  {itemsData?.length &&
                    itemsData
                      .filter(
                        (item, idx, self) =>
                          idx === self.findIndex((t) => t.item === item.item)
                      )
                      .map((item, id) => (
                        <option
                          key={id}
                          value={`${item.item} ${item.quantity}`}
                          data-unit={item.unit}
                          data-unitprice={item.unitPrice}
                          data-cost={item.mrp}
                          data-tax={item.tax}
                          data-productid={item.productId}
                          data-product={item.item}
                          data-qty={item.quantity}
                          data-batch={item.batch}
                          data-hsn={item.hsn}
                          data-expiry={item.expiry}
                        />
                      ))}
                </datalist>
              </td>

              <td>
                <Input
                  type="text"
                  value={row.hsn ?? ""}
                  onChange={(e) => handleInputChange(e, index, "hsn")}
                />
              </td>

              <td>
                <Input
                  type="number"
                  min="0"
                  value={row.quantity ?? ""}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => qtyHandler(e, index, "quantity")}
                />
              </td>
              <td>
                <select
                  value={row.unit ?? ""}
                  onChange={(e) => handleInputChange(e, index, "unit")}
                >
                  <option value="">Select Unit</option>
                  <option value="Kg">Kg</option>
                  <option value="g">g</option>
                  <option value="L">L</option>
                  <option value="mL">mL</option>
                  <option value="PC">PC</option>
                  <option value="No">No</option>
                  <option value="Tray">Tray</option>
                  <option value="Bag">Bag</option>
                  <option value="Pkt">Pkt</option>
                  <option value="Cylnd">Cylnd</option>
                  <option value="LTRS">LTRS</option>
                </select>
              </td>

              <td>
                <Input
                  type="text"
                  value={row.unitPrice ?? ""}
                  onChange={(e) => handleInputChange(e, index, "unitPrice")}
                />
              </td>

              <td>
                <Input
                  type="select"
                  value={row.tax ?? ""}
                  onChange={(e) => handleInputChange(e, index, "tax")}
                >
                  {taxOptions.map((option, id) => (
                    <option key={id} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Input>
              </td>

              <td>
                <Input
                  type="text"
                  value={row.mrp ?? ""}
                  onChange={(e) => handleInputChange(e, index, "mrp")}
                />
              </td>

              <td
                onClick={() => {
                  setRowIndex(index);
                  if (row.item) {
                    setFormData(row);
                    toggle();
                  } else {
                    alert("Please Enter Item");
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <span style={{ fontSize: "1.2rem", cursor: "pointer" }}>
                  &#8230;
                </span>
              </td>
              <td>
                <FiMinusCircle
                  onClick={() => {
                    if (
                      row.item ||
                      row.quantity ||
                      row.unitPrice ||
                      row.tax ||
                      row.mrp ||
                      row.hsn
                    ) {
                      const confirmDelete = window.confirm(
                        "This row contains item data. Are you sure you want to delete it?"
                      );
                      if (!confirmDelete) return;
                    }

                    const updated = invoiceSheet.filter((_, i) => i !== index);
                    setInvoiceSheet(updated);
                  }}
                  style={{ cursor: "pointer", color: "red" }}
                />
              </td>
            </tr>
          ))}

          <tr>
            <td colSpan={1}></td>
            <td
              style={{
                textAlign: "end",
                fontWeight: "bold",
                paddingTop: "15px",
              }}
            >
              Total
            </td>
            <td></td>
            <td style={{ textAlign: "center" }}>{totalQTY}</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: "center" }}></td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td
              colSpan={8}
              onClick={() => {
                const newRow = {
                  item: "",
                  quantity: "",
                  unit: "",
                  unitPrice: 0,
                  tax: 0,
                  mrp: 0,
                  hsn: "",
                  productId: "",
                };
                setInvoiceSheet([...invoiceSheet, newRow]);
              }}
              style={{ cursor: "pointer" }}
            >
              {mode !== "Return Mode" && (
                <FiPlusCircle style={{ fontSize: "1.5rem", color: "blue" }} />
              )}
            </td>
          </tr>
        </tbody>
      </Table>
      <Row>
        <Col className="d-flex justify-content-end">
          <Col sm={1}>
            {
              // error needs ti be fixed with componentRef
              //  mode === "Return Mode" && "888"
              //   <ReactToPrint
              //     trigger={() => <button className="glass-button">Print</button>}
              //     content={() => componentRef.current}
              //   />
            }
          </Col>

          <Button
            color="primary"
            onClick={() => {
              const x = window.confirm("Confirm to cancel the invoice entry");
              if (x === true) {
                clearForm();
              }
            }}
            className="me-2"
          >
            Clear
          </Button>
          {
          <Button color="primary" onClick={handleSubmit}>
            {editInventoryData
              ? "Update Inventory"
              : mode === "Return Mode"
              ? "Save Return"
              : "Save Purchase"}
          </Button>
          }
          {
       //   <Button onClick={()=> inventoryEditHandlerNew(invoiceSheet)}>InventoryEdit</Button>
           } </Col>
      </Row>
      {
        //Inventory form starts with inventory batch, expiry etc.. acces by clicking +
      }
      <Modal isOpen={modal} toggle={toggle} style={{ maxWidth: "70%" }}>
        <ModalHeader toggle={toggle}>Add Inventory</ModalHeader>

        <ModalBody>
          <InventoryForm
            formDataPurchase={formData}
            rowIndex={rowIndex}
            setInventoryFormData={setInventoryFormData}
            toggle={toggle}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <div style={{ display: "none" }}>
        <PrintBill
          ref={componentRef}
          data={purchaseInvoiceFormData}
          address={addressPrint}
          invoice_id={purchaseInvoiceFormData?.paymentDetails?.invoice_id}
          date={date}
          invoiceSheet={invoiceSheet}
          //     total={total}
          //     payment_mode={payments.map((payment) => payment.mode).join(", ")}
          //     branch={branch}
          GSTIN={GSTIN}
          //     formData={formData}
          supplier={supplierData?.find(
            (sup) =>
              sup.supplierId === purchaseInvoiceFormData?.supplier?.supplierId
          )}
        />
      </div>
    </Container>
  );
};

export default PurchaseEntry;
